import { RightOutlined } from '@ant-design/icons'
import { DataSource } from '@shared/innmaxLib/services'

function Table<T = any>(props: {
  onMobileRowRender?: (record: T) => React.ReactNode
  onRowClick?: (record: T) => void
  dataSource?: DataSource<T>
}) {
  const { onMobileRowRender, dataSource, onRowClick, ...others } = props

  return (
    <div>
      <div className="flex gap-5 text-white opacity-50">
        <span>{dataSource?.total || 0}</span>
        <span>筆</span>
      </div>
      <div>
        {dataSource?.content?.length === 0 && (
          <div className="flex justify-center items-center h-[200px]">
            <span className="text-secondary">無資料</span>
          </div>
        )}
      </div>
      {dataSource?.content?.map((record, index) => (
        <div
          onClick={() => onRowClick?.(record)}
          key={index}
          className="bg-[#ffffff0d] my-15 py-10 px-25 rounded-[4px] relative">
          {onMobileRowRender?.(record) || JSON.stringify(record)}
          {onRowClick && (
            <div className="absolute right-10 top-[25%]">
              <RightOutlined className="text-primary" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default Table
